export default "__VITE_ASSET__8227c50f__"